import { ModalStartScreenComponent } from './../shared/modals/modal-start-screen/modal-start-screen.component';
import { ModalSaveComponent } from './../shared/modals/modal-save/modal-save.component';
import { ModalSettingsComponent } from './../shared/modals/modal-settings/modal-settings.component';
import { ModalHelpComponent } from './../shared/modals/modal-help/modal-help.component';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TourNavigationService } from '../services/tour-navigation.service';
import { TourService } from '../services/tour.service';
import { Steps } from '../shared/steps-model';
import { StageService } from '../services/stage.service';
import { AuthService } from '../services/auth.service';
import { RendererService } from '../services/renderer.service';
import { SnapShotService } from '../services/snap-shot.service';
import { AppSettingsService } from '../services/app-settings.service';
import { ModalLogoutComponent } from '../shared/modals/modal-logout/modal-logout.component';
import { ModalViewSnapshotComponent } from '../shared/modals/modal-view-snapshot/modal-view-snapshot.component';
import { ProjectManagerService } from '../services/project-manager.service';
import { ModalShareEmailComponent } from '../shared/modals/modal-share-email/modal-share-email.component';
import { ImageUtilsService } from '../services/image-utils.service';
import { EventLogService } from '../services/eventLog';
import { ProToolsUiManagerService } from '../services/pro-tools-ui-manager.service';
import { ToasterService } from 'angular2-toaster';
import { SalesDashboardService } from '../services/sales-dashboard.service';
import { ViewSwitcherService } from '../services/view-switcher.service';
import { PdfService } from '../services/pdf.service';
import { SceneryService } from '../services/scenery.service';
import { AnalyticsService } from '../services/analytics.service';
import { AiSettingsDialogService } from '../services/ai-settings-dialog.service';

declare const THREE: any;

@Component({
  selector: 'app-top-toolbar',
  templateUrl: './top-toolbar.component.html',
  styleUrls: ['./top-toolbar.component.scss']
})
export class TopToolbarComponent implements OnInit {
  // showProjectTour = false;
  // showViewingTour = false;
  // showSettingsTour = false;

  is2D: boolean = true;
  isAuthorization: boolean = false;
  isAdmin: boolean = false;
  isSiteAdmin: boolean = false;
  isSavedProject: boolean = false;
  tourStep: number;
  disableCameraSwitch: boolean = false;
  currentSettingItem: string = '';
  isProToolsMode: boolean = false;

  public isShowDimensions: boolean;

  constructor(
    public dialog: MatDialog,
    private tourNavigationService: TourNavigationService,
    private vfTour: TourService,
    private stage: StageService,
    private auth: AuthService,
    private rendererSrvc: RendererService,
    private snapShotSrvc: SnapShotService,
    private appSetting: AppSettingsService,
    private projectSrvc: ProjectManagerService,
    private imageUtilsService: ImageUtilsService,
    private eventLogSrvc: EventLogService,
    private proToolsUiManagerService: ProToolsUiManagerService,
    private toasterService: ToasterService,
    private salesDashboardService: SalesDashboardService,
    private viewSwitcher: ViewSwitcherService,
    private pdfService: PdfService,
    private env: SceneryService,
    private analyticsService: AnalyticsService,
    private aiSettingsDialogService: AiSettingsDialogService
  ) {
    this.imageUtilsService.isShowDimensionsObservable.subscribe(v => {
      this.isShowDimensions = v;
      this.changeToggleIcon();
    });
    this.projectSrvc.isSavedProject.subscribe(value => (this.isSavedProject = value));
    this.viewSwitcher.needViewModeIconUpdate.subscribe(value => {
      this.switchTo2D(value);
    });
    this.proToolsUiManagerService.proToolsModActive.subscribe(value => {
      if (value) {
        this.isProToolsMode = true;
      } else {
        this.isProToolsMode = false;
      }
    });
  }

  switchTo2D(value: boolean) {
    if (this.proToolsUiManagerService.getIsProToolsMode() && !value) {
      this.showToast('warning', 'Warning', '3D view is not available in Pro Tools mode');
      return;
    }
    this.viewSwitcher.switchView(value);
    this.is2D = value;
  }

  setCurrentSetting(value: string) {
    this.currentSettingItem = value;
  }

  print(): void {
    if (!this.isSavedProject) {
      this.showToast('warning', 'Warning', 'Print function is available for saved projects only');
    } else {
      this.pdfService.printProject();
    }
  }

  takeSnapshot() {
    const snapshot = this.rendererSrvc.getScreenShot();
    const projectId = this.projectSrvc.getCurrentProjectId();
    // html2canvas(document.body).then(function(canvas) {
    //   snapshot = canvas;
    // });
    this.publishSnapshot(snapshot);
    const curSnapshots = this.snapShotSrvc.getSnapshots();
    if (this.isSavedProject) {
      this.snapShotSrvc
        .persistSnapshotsForProject(projectId, curSnapshots)
        .subscribe(saved => this.snapShotSrvc.setSnapshots(saved));
    }
    this.showToast(
      'success',
      'Success',
      'Snapshot taken. Access your snapshots from My Projects menu.'
    );
  }

  publishSnapshot(snapshot: any) {
    this.snapShotSrvc.pushSnapshot(snapshot);
  }

  openSnapshotDialog() {
    const dialogRef = this.dialog.open(ModalViewSnapshotComponent, {
      width: '500px',
      height: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Logout dialog was closed');
    });
  }

  logout() {
    // this.auth.setIsAuthorization(false);
    // this.auth.setRole("");

    // check if there is at least one tier added
    // if so, ask if user wants to save
    if (this.stage.getCompoundFloor().children.length) {
      const dialogRef = this.dialog.open(ModalLogoutComponent, {
        width: '400px',
        height: '200px'
      });

      dialogRef.afterClosed().subscribe(result => {
        // console.log('Logout dialog was closed');
      });
    } else {
      this.projectSrvc.clearProject();
      this.auth.clearAuthorization();
      this.env.change('grid');
      this.auth.logout();
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('isAuthorization');
      this.analyticsService.onUserLoggedOut();
    }
  }

  login() {
    const dialogRef = this.dialog.open(ModalStartScreenComponent, {
      width: '835px',
      height: '75vh',
      data: 'login'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Start screen dialog was closed');
    });
  }

  editProfile(): void {
    const dialogRef = this.dialog.open(ModalStartScreenComponent, {
      width: '835px',
      height: '75vh',
      data: 'editProfile'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Start screen dialog was closed');
    });
  }

  openNewProjectDialog(type: string): void {
    const dialogRef = this.dialog.open(ModalStartScreenComponent, {
      width: '835px',
      height: '75vh',
      data: type
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Start screen dialog was closed');
    });
  }

  openSaveDialog(): void {
    const dialogRef = this.dialog.open(ModalSaveComponent, {
      width: '455px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Rename dialog was closed');
    });
  }

  openHelpDialog(): void {
    const dialogRef = this.dialog.open(ModalHelpComponent, {
      width: '335px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Help dialog was closed');
    });
  }

  openShareDialog(): void {
    const shareDialog = this.dialog.open(ModalShareEmailComponent, {
      width: '500px',
      data: 'shareProject'
    });

    shareDialog.afterClosed().subscribe(result => {
      // console.log('Share dialog was closed');
    });
  }

  openSettingsDialog(): void {
    const dialogRef = this.dialog.open(ModalSettingsComponent, {
      width: '335px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Settings dialog was closed');
    });
  }

  undo() {
    this.eventLogSrvc.revert();
  }

  openTour(): void {
    this.tourNavigationService.changeTourStep(1);
  }

  openVfTour(): void {
    this.vfTour.showTour();
  }

  setDimensions() {
    this.imageUtilsService.isShowDimensionsSubject.next(!this.isShowDimensions);
    this.changeToggleIcon();
    if (this.isShowDimensions) {
      this.imageUtilsService.showSprites();
    } else {
      this.imageUtilsService.hideSprites();
    }
  }

  changeToggleIcon() {
    const img: any = document.getElementsByClassName('icon-dimensions')[0];
    if (img) {
      if (this.isShowDimensions) {
        img.style.backgroundImage = "url('../../assets/images/Show_dim2.png')";
      } else {
        img.style.backgroundImage = "url('../../assets/images/hide_dim2.png')";
      }
    }
  }

  ngOnInit() {
    // this.tourNavigationService.Navigator.subscribe(
    //   value => {
    //       this.tourStep = value;
    //   }
    // );
    this.isAuthorization = JSON.parse(sessionStorage.getItem('isAuthorization'));
    this.updateRoleFlags();
    this.auth.isAuthorization.subscribe(auth => {
      this.isAuthorization = auth;
      this.updateRoleFlags();
    });
    this.vfTour.showCurrentStep.subscribe((stepItem: Steps) => {
      this.tourStep = stepItem.step;
    });
  }

  showToast(type: string, title: string, body: string): void {
    this.toasterService.popAsync(type, title, body);
  }

  showSalesDashboard() {
    this.salesDashboardService.showDashboard();
  }

  openAiSettings(): void {
    this.aiSettingsDialogService.open();
  }

  private updateRoleFlags(): void {
    const role = this.auth.getRole();
    this.isSiteAdmin = role === 'admin';
    this.isAdmin = role === 'admin' || role === 'salesManager';
  }
}



// WEBPACK FOOTER //
// ./src/app/top-toolbar/top-toolbar.component.ts